import { render, staticRenderFns } from "./goodsdetails.vue?vue&type=template&id=3a5b76af&scoped=true"
import script from "./goodsdetails.vue?vue&type=script&lang=js"
export * from "./goodsdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b76af",
  null
  
)

export default component.exports